import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { maxBy, isEmpty } from 'lodash'

import Details from '../../../components/tabs/OrderDetailsModal/Details'

import { setActiveCustomer } from '../../../actions/suites/customer'
import { setActiveRevenueCenter } from '../../../actions/revenueCenter'
import { reopenOrder } from '../../../actions/order'
import { updateUserNotes } from '../../../actions/orders/patch'

import { makeGetTabOrder } from '../../../selectors/order'
import { makeGetCurrentMenu } from '../../../selectors/menus'
import { makeGetDisplaySuiteByOrder } from '../../../selectors/suites'
import { getIsSuitesMode } from '../../../selectors/config'

import { TabOrderDetailsViewModel } from '../../../viewmodels/TabOrderViewModel'
import PaymentTypes from '../../../utils/paymentTypes'
import { SIGNATURE_THRESHOLD_AMOUNT } from '../../../constants'

const mapStateToProps = (state, ownProps) => {
  const orderId = ownProps?.match?.params?.orderId ?? ''
  const getTabOrder = makeGetTabOrder()
  const getDisplaySuite = makeGetDisplaySuiteByOrder()
  const suiteInformation = getDisplaySuite(state, orderId)
  const tabOrder = getTabOrder(state, orderId)
  const order = TabOrderDetailsViewModel(tabOrder)
  const remoteOrderTotal = maxBy([order.orderTotalFromOrder, order.remoteOrderTotal], 'updatedAt') || {}

  const customerId = order?.customerId ?? ''
  const revenueCenterId = order?.revenueCenterUuid ?? ''
  const userNotes = order?.userNotes ?? ''
  const isOrderLatestFromServer = tabOrder?.latestFromServer ?? false
  const isSuitesMode = getIsSuitesMode(state)
  const isRichCheckout = PaymentTypes.isMobileWalletPayment(order.paymentType)
  const authorizationFailed = order?.orderState === 'authorization_failed'
  const signatureRequired = SIGNATURE_THRESHOLD_AMOUNT === 0 || (SIGNATURE_THRESHOLD_AMOUNT && remoteOrderTotal.totalAmountInCents >= SIGNATURE_THRESHOLD_AMOUNT)
  const menu = makeGetCurrentMenu()(state)
  const isNoTipMenu = isEmpty(menu?.tipSuggestions)


  return {
    ...order,
    customerId,
    isOrderLatestFromServer,
    remoteOrderTotal,
    revenueCenterId,
    suiteInformation,
    isSuitesMode,
    isRichCheckout,
    authorizationFailed,
    userNotes,
    signatureRequired,
    isNoTipMenu
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const orderId = ownProps?.match?.params?.orderId ?? ''
  const replace = ownProps?.history?.replace ?? function(){}

  return {
    onClose: () => replace('/tabs'),
    onAddServiceRound: (customerId, revenueCenterId) => {
      dispatch(setActiveCustomer(customerId))
      dispatch(setActiveRevenueCenter(revenueCenterId))
      replace(`/tab-order/${orderId}`)
    },
    onReopenOrder: (uuid) => dispatch(reopenOrder(uuid)),
    onUpdateUserNotes: (userNotes) => dispatch(updateUserNotes(orderId, userNotes))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Details))
